module.exports = __webpack_public_path__ + "img/solution-path.0f1e488b.png";